<template>
    <b-form @submit.prevent="openModalConfirm">
        <div class="form-parameter-wrapper">
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Maksimum Gadai Elektronik" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="anggotaInput.MAX_GADAI_ELEK" name="maxGadaiElek" type="number" required></b-form-input>
                        <span class="smallText text-muted">Jumlah maksimum gadai elektronik berjalan per anggota</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Maksimum Gadai Kendaraan" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="anggotaInput.MAX_GADAI_KEND" name="maxGadaiKendaraan" type="number" required></b-form-input>
                        <span class="smallText text-muted">Jumlah maksimum gadai Kendaraan berjalan per anggota</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Maksimum Gadai BPKB" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="anggotaInput.MAX_GADAI_BPKB" name="maxGadaiBpkb" type="number" required></b-form-input>
                        <span class="smallText text-muted">Jumlah maksimum gadai BPKB berjalan per anggota</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Maksimum Gadai per Jenis" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="anggotaInput.MAX_GADAI_JENIS" name="maxGadaiPerJenis" type="number" required></b-form-input>
                        <span class="smallText text-muted">Jumlah maksimum jenis barang pada gadai berjalan per anggota</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bonus Gadai Pertama" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="anggotaInput.BONUS_GADAI_PERTAMA" name="bonusGadaiPertama" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Nominal tambahan yang diberikan untuk penggadaian pertama anggota</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Status Macet" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="anggotaInput.ADJUST_MACET" id="persenAdjustMacet" name="persenStatusMacet" step="0.01" @blur="roundPersen(1)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Adjustment persentase pinjaman untuk anggota dengan status macet</span>
                    </b-col>
                </b-row>
                <b-popover target="persenAdjustMacet" title="Catatan" triggers="focus">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                        </li>
                        <li class="mb-2">
                            <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                        </li>
                        <li class="mb-0">
                            <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                        </li>
                    </ul>
                </b-popover>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Status Kurang Lancar" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="anggotaInput.ADJUST_KURANG_LANCAR" id="persenAdjustKurangLancar" name="persenStatusKurangLancar" step="0.01" @blur="roundPersen(2)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Adjustment persentase pinjaman untuk anggota dengan status kurang lancar</span>
                    </b-col>
                </b-row>
                <b-popover target="persenAdjustKurangLancar" title="Catatan" triggers="focus">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                        </li>
                        <li class="mb-2">
                            <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                        </li>
                        <li class="mb-0">
                            <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                        </li>
                    </ul>
                </b-popover>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Status Lancar" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="anggotaInput.ADJUST_LANCAR" id="persenAdjustLancar" name="persenStatusLancar" step="0.01" @blur="roundPersen(3)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Adjustment persentase pinjaman untuk anggota dengan status lancar</span>
                    </b-col>
                </b-row>
                <b-popover target="persenAdjustLancar" title="Catatan" triggers="focus">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                        </li>
                        <li class="mb-2">
                            <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                        </li>
                        <li class="mb-0">
                            <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                        </li>
                    </ul>
                </b-popover>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Anggota Baru" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="anggotaInput.ADJUST_BARU" id="persenAdjustBaru" name="persenAnggotaBaru" step="0.01" @blur="roundPersen(4)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Adjustment persentase pinjaman untuk anggota baru (dibawah 5 pembayaran)</span>
                    </b-col>
                </b-row>
                <b-popover target="persenAdjustBaru" title="Catatan" triggers="focus">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                        </li>
                        <li class="mb-2">
                            <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                        </li>
                        <li class="mb-0">
                            <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                        </li>
                    </ul>
                </b-popover>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Hitungan Hari Macet" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="anggotaInput.HARI_MACET" name="hitunganHariMacet" type="number" required></b-form-input>
                        <span class="smallText text-muted">Hari keterlambatan pembayaran yang dikategorikan sebagai pembayaran macet</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Hitungan Hari Kurang Lancar" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="anggotaInput.HARI_KURANG_LANCAR" name="hitunganHariKurangLancar" type="number" required></b-form-input>
                        <span class="smallText text-muted">Hari keterlambatan pembayaran yang dikategorikan sebagai pembayaran kurang lancar</span>
                    </b-col>
                </b-row>
            </b-form-group>
        </div>
        <div class="form-wrapper-btn submit-btn-wrapper">
            <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
        </div>
        <ModalConfirm id="modal-edit-anggota" title="Confirm Edit Parameter Anggota" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah parameter anggota ini?" @submit="onSubmit" />
    </b-form>
</template>

<script>
export default {
    name: 'anggota',
    props: {
        anggotaInput: { type: Object, required: true }
    },
    data(){
        return{
            isSubmitting: false,
            newData: {}
        }
    },
    watch: {
        "anggotaInput.BONUS_GADAI_PERTAMA": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.anggotaInput.BONUS_GADAI_PERTAMA = result);
        },
    },
    methods: {

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {

            this.newData = JSON.parse(JSON.stringify(this.anggotaInput))
            
            const bonusGadaiPertama = this.$helper.removeThousandSeparator(this.newData.BONUS_GADAI_PERTAMA);
            this.newData.BONUS_GADAI_PERTAMA = bonusGadaiPertama;

            let payload = new FormData()
            
            for (let [key, value] of Object.entries(this.newData)) {
                payload.append("name", key)
                payload.append("value", value)
            }
            
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("parameter/update/", payload).then(() => {
                this.$helper.toastSucc(this, "Parameter Anggota telah berhasil diubah!")
                this.$bvModal.hide("modal-edit-anggota")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },
        
        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------
        
        openModalConfirm(){
            this.$bvModal.show("modal-edit-anggota")
        },

        roundPersen(id){
            if(id == 1){
                var persenStatusMacet = Number(this.anggotaInput.ADJUST_MACET).toFixed(2);
                this.anggotaInput.ADJUST_MACET = persenStatusMacet;
            }else if(id == 2){
                var persenStatusKurangLancar = Number(this.anggotaInput.ADJUST_KURANG_LANCAR).toFixed(2);
                this.anggotaInput.ADJUST_KURANG_LANCAR = persenStatusKurangLancar;
            }else if(id == 3){
                var persenStatusLancar = Number(this.anggotaInput.ADJUST_LANCAR).toFixed(2);
                this.anggotaInput.ADJUST_LANCAR = persenStatusLancar;
            }else{
                var persenAnggotaBaru = Number(this.anggotaInput.ADJUST_BARU).toFixed(2);
                this.anggotaInput.ADJUST_BARU = persenAnggotaBaru;
            }
        }
    },
    created(){
        
    }
}
</script>